import config from "../../../helper/config";
import APIHandler from "../../../handlers/APIHandler";

export const CombankService = {
    getSessionID,
    retrieveOrder,
    getSessionIDAssessmentPurchase,
    getSessionIDAssessmentPackagePurchase,
    getSessionIDCartPurchase,
    retrieveOrderForAssessmentPackagePurchase,
    retrieveOrderForAssessment,
    retrieveOrderForCartPurchase
};

async function getSessionID(combank_obj) {
    const requestOptions = {
        method: "POST",
        headers: {
            ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
            "Content-Type": "application/json",
        },
        body: combank_obj,
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/subscription/combank-pg/getSessionId`,
        requestOptions
    );
    return APIHandler.handleResponse(response);
}

async function getSessionIDAssessmentPurchase(combank_obj) {
    const requestOptions = {
        method: "POST",
        headers: {
            ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
            "Content-Type": "application/json",
        },
        body: combank_obj,
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/assessment-subscription/combank_exam_pg/getSessionIdAssessmentPurchase`,
        requestOptions
    );
    return APIHandler.handleResponse(response);
}

async function getSessionIDAssessmentPackagePurchase(combank_obj) {
    const requestOptions = {
        method: "POST",
        headers: {
            ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
            "Content-Type": "application/json",
        },
        body: combank_obj,
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/assessment-subscription/combank_exam_pg/getSessionIdAssessmentPackagePurchase`,
        requestOptions
    );
    return APIHandler.handleResponse(response);
}

async function getSessionIDCartPurchase(cart_payment_obj) {
    const requestOptions = {
        method: "POST",
        headers: {
            ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
            "Content-Type": "application/json",
        },
        body: cart_payment_obj,
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/assessment-subscription/combank_exam_pg/getSessionIdCartPurchase`,
        requestOptions
    );
    return APIHandler.handleResponse(response);
}

async function retrieveOrderForCartPurchase(session_id) {
    const requestOptions = {
        method: "GET",
        headers: {
            ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
            "Content-Type": "application/json",
        },
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/assessment-subscription/combank_exam_pg/retrieve-order-for-cart-purchase/${session_id}`,
        requestOptions
    );
    return APIHandler.handleResponse(response);
}

async function retrieveOrder(session_id) {
    const requestOptions = {
        method: "GET",
        headers: {
            ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
            "Content-Type": "application/json",
        },
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/subscription/combank-pg/retrieve-order/${session_id}`,
        requestOptions
    );
    return APIHandler.handleResponse(response);
}

async function retrieveOrderForAssessment(session_id) {
    const requestOptions = {
        method: "GET",
        headers: {
            ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
            "Content-Type": "application/json",
        },
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/assessment-subscription/combank_exam_pg/retrieve-order-for-assessment/${session_id}`,
        requestOptions
    );
    return APIHandler.handleResponse(response);
}

async function retrieveOrderForAssessmentPackagePurchase(session_id) {
    const requestOptions = {
        method: "GET",
        headers: {
            ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
            "Content-Type": "application/json",
        },
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/assessment-subscription/combank_exam_pg/retrieve-order-for-assessment-package-purchase/${session_id}`,
        requestOptions
    );
    return APIHandler.handleResponse(response);
}